module.exports = __webpack_public_path__ + "img/6852d38.jpg";